import * as _ from "lodash";

console.debug("Initializing frontend-1.0 subsystem...");

import './components/form-validation';

import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia'

import {store} from "@/modules/store";
import {Application} from "@/helpers/app";

Vue.use(PiniaVuePlugin);

const pinia = createPinia()

if (process.env.NODE_ENV !== "production") {
  Vue.config.devtools = true;
}

export const rootVueInstance = new Vue({
  el: '#app-1_0',
  store: store,
  pinia: pinia,
  components: {
    // /* webpackPrefetch: true */

    'order-page': () => import('./modules/entrys/order.vue'),
    'finalize-account': () => import('./modules/entrys/finalize-account.vue'),
    'finalize-property': () => import('./modules/entrys/finalize-property.vue'),
    'bc-user-cabinet-view': () => import('./modules/user-cabinet/UserCabinetView.vue'),
    /*
    'order-page': require('./modules/entrys/order.vue').default,
    'finalize-account': require('./modules/entrys/finalize-account.vue').default,
    'finalize-property': require('./modules/entrys/finalize-property.vue').default,
     */
  },
  mounted() {
    console.debug("Root Vue Instance (1.0) mounted");

    Application.run();
  }
});

Object.assign(window, {
  "_": _,
  "root_vue_1_0": rootVueInstance
});
